module.exports = __webpack_public_path__ + "static/media/canto-link.7fe8bee5.jpg";